module.exports = __webpack_public_path__ + "static/media/catering.49d14470.svg";